import { useState } from 'react'
import type { ReportFormData, ReportListItem } from './types'
import { useIntl } from 'react-intl'
import ReportList from './ReportList'
import ReportDialog from './ReportDialog'

type ReportsViewProps = {
	reportItems: ReportListItem[]
	reportForms: Record<string, ReportFormData>
}

const ReportsView = (props: ReportsViewProps) => {
	const { reportItems, reportForms } = props
	const intl = useIntl()
	const [selectedFormKey, setSelectedFormKey] = useState<string | null>(null)
	const reportDialogTitle = reportItems
		.find((item) => item.key === selectedFormKey)
		?.title(intl)
	const selectedFormData: ReportFormData | null =
		reportForms[selectedFormKey!] ?? null

	return (
		<div>
			<ReportList
				reportItems={reportItems}
				setSelectedFormKey={setSelectedFormKey}
			/>

			{selectedFormData ? (
				<ReportDialog
					title={
						reportDialogTitle ??
						intl.formatMessage({
							defaultMessage: 'Raportti',
							description: 'Title for report dialog when no title is found',
						})
					}
					formData={selectedFormData}
					onHide={() => {
						setSelectedFormKey(null)
					}}
				/>
			) : null}
		</div>
	)
}
export default ReportsView
